"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _react = _interopRequireDefault(require("react"));
var _useProductRowPrice2 = _interopRequireDefault(require("./useProductRowPrice"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _Product = _interopRequireDefault(require("@deosite/ui-entities/Product"));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ProductRowPrice = function ProductRowPrice(_ref) {
  var _extendedStyles$cross, _extendedStyles$produ, _extendedStyles$final, _extendedStyles$final2, _extendedStyles$produ2;
  var price = _ref.price,
    isOrderView = _ref.isOrderView,
    opacityStyle = _ref.opacityStyle,
    isQuantityPickerEnabled = _ref.isQuantityPickerEnabled,
    quantityPicker = _ref.quantityPicker,
    extendedStyles = _ref.extendedStyles,
    quantity = _ref.quantity,
    showDiscountFromTotals = _ref.showDiscountFromTotals;
  var _useProductRowPrice = (0, _useProductRowPrice2["default"])({
      price: price,
      isQuantityPickerEnabled: isQuantityPickerEnabled,
      quantityPicker: quantityPicker,
      quantity: quantity,
      showDiscountFromTotals: showDiscountFromTotals
    }),
    finalRegularPrice = _useProductRowPrice.finalRegularPrice,
    finalPrice = _useProductRowPrice.finalPrice,
    isProductForFree = _useProductRowPrice.isProductForFree,
    hasDiscount = _useProductRowPrice.hasDiscount;
  var translations = {
    productForFree: (0, _langLibrary["default"])("Product for free")
  };
  var orderViewProps = isOrderView ? {
    width: "100%",
    textAlign: "right"
  } : {};
  if (isProductForFree) {
    return __jsx(_Box["default"], {
      sx: orderViewProps
    }, __jsx(_Box["default"], {
      sx: _objectSpread(_objectSpread({}, opacityStyle), {}, {
        font: "s_sans_bold",
        display: isQuantityPickerEnabled ? "block" : "flex",
        justifyContent: isOrderView ? "flex-end" : "flex-start",
        color: "positive"
      })
    }, translations.productForFree));
  }
  return __jsx(_Box["default"], {
    sx: orderViewProps
  }, hasDiscount ? __jsx(_Box["default"], {
    sx: _objectSpread(_objectSpread({}, opacityStyle), {}, {
      display: isQuantityPickerEnabled ? "block" : "flex",
      justifyContent: isOrderView ? "flex-end" : "flex-start"
    })
  }, __jsx(_Box["default"], {
    sx: {
      font: isQuantityPickerEnabled ? "s_sans" : (_extendedStyles$cross = extendedStyles === null || extendedStyles === void 0 ? void 0 : extendedStyles.crossedOutPriceFont) !== null && _extendedStyles$cross !== void 0 ? _extendedStyles$cross : "xs_underline",
      color: (_extendedStyles$produ = extendedStyles === null || extendedStyles === void 0 ? void 0 : extendedStyles.productFontColor) !== null && _extendedStyles$produ !== void 0 ? _extendedStyles$produ : "main",
      textDecoration: "line-through",
      order: 1
    }
  }, finalRegularPrice), __jsx(_Box["default"], {
    sx: {
      font: isQuantityPickerEnabled ? "s_sans_bold" : (_extendedStyles$final = extendedStyles === null || extendedStyles === void 0 ? void 0 : extendedStyles.finalPriceFont) !== null && _extendedStyles$final !== void 0 ? _extendedStyles$final : "xs_underline",
      textDecoration: "none",
      color: "negative",
      order: 0,
      mr: "s5"
    },
    "data-test": "price-product-row"
  }, finalPrice)) : __jsx(_Box["default"], {
    sx: _objectSpread(_objectSpread({}, opacityStyle), {}, {
      font: isOrderView || isQuantityPickerEnabled ? "s_sans_bold" : (_extendedStyles$final2 = extendedStyles === null || extendedStyles === void 0 ? void 0 : extendedStyles.finalPriceFont) !== null && _extendedStyles$final2 !== void 0 ? _extendedStyles$final2 : "xs_underline",
      textDecoration: "none",
      color: (_extendedStyles$produ2 = extendedStyles === null || extendedStyles === void 0 ? void 0 : extendedStyles.productFontColor) !== null && _extendedStyles$produ2 !== void 0 ? _extendedStyles$produ2 : "main",
      margin: "auto 0"
    }),
    "data-test": "price-product-row"
  }, finalRegularPrice));
};
var _default = ProductRowPrice;
exports["default"] = _default;